var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRefactrLogo = function SvgRefactrLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37.982 35.517",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M37.982 35.517h-8.04v-3.946h3.882V3.946h-3.882V0h8.04v35.517zm-29.942 0H0V0h8.04v3.946H4.159v27.625H8.04v3.946z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    fill: "#00a2e8",
    d: "M6 5.932h8v7H6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9",
    fill: "#00a2e8",
    d: "M6 13.932h8v7H6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12",
    fill: "#00a2e8",
    d: "M6 21.932h8v8H6z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5",
    fill: "#00a2e8",
    d: "M15 5.932h8v7h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8",
    fill: "#080808",
    d: "M15 13.932h8v7h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    fill: "#080808",
    d: "M15 21.932h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6",
    fill: "#00a2e8",
    d: "M24 5.932h8v7h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7",
    fill: "#080808",
    d: "M24 13.932h8v7h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    fill: "#00a2e8",
    d: "M24 21.932h8v8h-8z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefactrLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refactr-logo.d12de8c5.svg";
export { ForwardRef as ReactComponent };